import React from "react";
import Script from "next/script";
import settings, {
    DEFAULT_USER_CENTRICS_ID,
    SETTING_USER_CENTRICS_ID,
    SETTING_USER_CENTRICS_VERSION, SETTINGS_DISABLE_USER_CENTRICS_FOR_CURRENT_PAGE
} from "../../pages/config/settings";


interface Props {
    pageProps: any,
}

const UC_SCRIPT = "https://web.cmp.usercentrics.eu/ui/loader.js";
const UC_SCRIPT_ID = "usercentrics-cmp";
const UC_LOADER_ID = "usercentrics-cmp-loader";

const toInlineScriptValue = (value: unknown) => JSON.stringify(value).replace(/</g, "\\u003c");

const buildLoader = (attributes: Record<string, string>) => `(function () {
    if (document.getElementById(${toInlineScriptValue(UC_SCRIPT_ID)})) return;
    try {
        const ancestorOrigins = window.location.ancestorOrigins;
        const isEmbeddedInStudio = ancestorOrigins
            ? !!(ancestorOrigins[0] && ancestorOrigins[0].indexOf("studio.") > -1)
            : window.parent !== window;
        if (isEmbeddedInStudio) return;
    } catch (e) {}
    const attributes = ${toInlineScriptValue(attributes)};
    const script = document.createElement("script");
    Object.keys(attributes).forEach(function (name) {
        script.setAttribute(name, attributes[name]);
    });
    document.head.appendChild(script);
})();`;

const isE2eTest = () => {
    if (typeof window === 'undefined') return false;
    try {
        const url = window.location.href;
        return url && (url.startsWith("/e2etest") || (url.indexOf("e2etest=true") > -1));
    } catch {
        return false;
    }
}

function Usercentrics({pageProps}: Props) {
    const ucVersion = settings(pageProps.CAEGlobalSettings, SETTING_USER_CENTRICS_VERSION);
    const ucId = settings(pageProps.CAEGlobalSettings, SETTING_USER_CENTRICS_ID, DEFAULT_USER_CENTRICS_ID);
    const isTurnOffUsercentrics = pageProps?.page?.marketingSettings?.[SETTINGS_DISABLE_USER_CENTRICS_FOR_CURRENT_PAGE] || isE2eTest();

    if (isTurnOffUsercentrics) {
        return null;
    }

    const loader = buildLoader({
        id: UC_SCRIPT_ID,
        src: UC_SCRIPT,
        "data-settings-id": ucId,
        "data-language": "de",
        ...(ucVersion === "preview" ? {"data-draft": "true"} : {})
    });

    return (
        // eslint-disable-next-line @next/next/no-before-interactive-script-outside-document -- Must run before hydration and depends on pageProps; revisit when migrating to the App Router.
        <Script
            id={UC_LOADER_ID}
            strategy="beforeInteractive"
            dangerouslySetInnerHTML={{__html: loader}}
        />
    );
}

export default Usercentrics
